export default {
  state: {
    trx: {
      list: []
    }
  },
  mutations: {
    setTrxData (state, data) {
      for (let field in data) {
        state.trx[field] = data[field]
      }
    },
    
  }
}



// WEBPACK FOOTER //
// ./src/store/flight-details/trx.js